import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Subject, takeUntil } from "rxjs";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { BrandingService } from "src/app/services/branding.service";
import { RETURN_URL, StorageService } from "src/app/services/storage.service";

import { AuthService } from "./../../services/auth.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  readonly routeNameConstants = RouteNameConstants;
  private readonly _destroying$ = new Subject<void>();

  invalidLogin: boolean;
  faSpinner = faSpinner;
  isLoading: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private brandingService: BrandingService,
    private storageService: StorageService,
  ) {
    this.isLoading = this.storageService.getLoginInProgressState();
  }

  async ngOnInit(): Promise<void> {
    this.authService.isLoggedIn$
      .pipe(takeUntil(this._destroying$))
      .subscribe(async (isLoggedIn: boolean) => {
        if (isLoggedIn) {
          await this.getUserProfile();
        }
      });
  }

  private async getUserProfile(): Promise<void> {
    this.isLoading = true;
    try {
      await this.authService.setUserProfile();
      this.navigateToReturnUrl();
    } finally {
      this.isLoading = false;
      this.storageService.clearLoginInProgressState();
    }
  }

  navigateToReturnUrl() {
    const returnUrl = this.storageService.getReturnUrl() ?? RouteNameConstants.ROOT;
    this.storageService.clearReturnUrl();
    this.router.navigate([returnUrl]);
  }

  loginToAzure() {
    this.isLoading = true;

    const returnUrl = this.route.snapshot.queryParamMap.get(RETURN_URL) || RouteNameConstants.ROOT;
    this.storageService.setReturnUrl(returnUrl);
    this.storageService.setIsLoginInProgressState();

    this.authService.login();
  }

  get brand(): string {
    return this.brandingService.getBrandTitle();
  }
  get link(): string {
    return this.brandingService.getBrandLink();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
